import React, { FC } from "react";
import { FilteringItem } from "./FilteringItem";
import { IFilteringItem } from "./types";
import { OutsideValuesMultiSelect } from "../OutsideValuesMultiSelect";
import { IOutsideValuesMultiSelect } from "../OutsideValuesMultiSelect/types";

interface Props extends IFilteringItem, IOutsideValuesMultiSelect {}

export const OutsideValuesMultiSelectFilteringItem: FC<Props> = ({
  label,
  icon,
  ...props
}) => (
  <FilteringItem label={label} icon={icon}>
    <OutsideValuesMultiSelect {...props} />
  </FilteringItem>
);
